/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum CardBrand {
    Upi = 'UPI',
    Amex = 'Amex',
    Diners = 'Diners',
    Discover = 'Discover',
    Jcb = 'JCB',
    Mastercard = 'Mastercard',
    Visa = 'Visa'
}

export function CardBrandFromJSON(json: any): CardBrand {
    return CardBrandFromJSONTyped(json, false);
}

export function CardBrandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CardBrand {
    return json as CardBrand;
}

export function CardBrandToJSON(value?: CardBrand | null): any {
    return value as any;
}

